import { 
  FaUsers, 
  FaRocket, 
  FaHandshake, 
  FaAward,
  FaHeart
} from 'react-icons/fa';
import styles from './AboutUs.module.css';

const AboutUs = () => {
  // const teamMembers = [
  //   {
  //     name: "Carlos Rodríguez",
  //     position: "CEO & Fundador",
  //     image: "https://randomuser.me/api/portraits/men/32.jpg",
  //     bio: "Con más de 10 años de experiencia en desarrollo de software y gestión de proyectos tecnológicos.",
  //     social: {
  //       linkedin: "#",
  //       twitter: "#",
  //       github: "#"
  //     }
  //   },
  //   {
  //     name: "Ana Martínez",
  //     position: "CTO",
  //     image: "https://randomuser.me/api/portraits/women/44.jpg",
  //     bio: "Especialista en arquitectura de software y desarrollo full-stack con enfoque en soluciones escalables.",
  //     social: {
  //       linkedin: "#",
  //       twitter: "#",
  //       github: "#"
  //     }
  //   },
  //   {
  //     name: "Miguel Sánchez",
  //     position: "Lead Designer",
  //     image: "https://randomuser.me/api/portraits/men/22.jpg",
  //     bio: "Apasionado por crear experiencias de usuario intuitivas y atractivas que conectan con las audiencias.",
  //     social: {
  //       linkedin: "#",
  //       twitter: "#",
  //       github: "#"
  //     }
  //   }
  // ];

  const values = [
    {
      icon: <FaRocket />,
      title: "Innovación",
      description: "Buscamos constantemente nuevas formas de resolver problemas y mejorar nuestras soluciones."
    },
    {
      icon: <FaHandshake />,
      title: "Compromiso",
      description: "Nos dedicamos a entregar resultados excepcionales y superar las expectativas de nuestros clientes."
    },
    {
      icon: <FaUsers />,
      title: "Colaboración",
      description: "Trabajamos en estrecha colaboración con nuestros clientes para garantizar el éxito de cada proyecto."
    },
    {
      icon: <FaHeart />,
      title: "Pasión",
      description: "Amamos lo que hacemos y eso se refleja en la calidad de nuestro trabajo y atención al detalle."
    }
  ];

  const stats = [
    { value: "10+", label: "Proyectos en Desarrollo" },
    { value: "15+", label: "Clientes Potenciales" },
    { value: "1", label: "Año de Planificación" },
    { value: "3", label: "Servicios Principales" }
  ];

  return (
    <>
      <section className={styles.aboutHero}>
        <div className={styles.heroContent}>
          <div className={styles.badge}>
            <FaUsers className={styles.badgeIcon} />
            <span>Sobre Nosotros</span>
          </div>
          <h1>Transformando <span>Ideas</span> en Soluciones Digitales</h1>
          <p>
            Somos un equipo apasionado de profesionales dedicados a crear soluciones 
            tecnológicas innovadoras que impulsan el crecimiento de nuestros clientes.
          </p>
        </div>
      </section>

      <section className={styles.storySection}>
        <div className={styles.storyContainer}>
          <div className={styles.storyContent}>
            <h2>Nuestra Historia</h2>
            <p>
              LUCQA nace como un ambicioso proyecto concebido en 2024, con una doble visión: revolucionar 
              la manera en que las empresas interactúan con la tecnología y transformar la gestión del 
              talento humano en el sector tecnológico. Lo que comenzó como una idea innovadora y un plan 
              meticulosamente desarrollado, está a punto de materializarse en 2025 como una empresa 
              integral de servicios tecnológicos y gestión de talento.
            </p>
            <p>
              Durante el último año, hemos dedicado nuestro tiempo a investigar el mercado, 
              desarrollar metodologías únicas y establecer conexiones estratégicas. Nuestro objetivo 
              es doble: por un lado, ofrecer soluciones tecnológicas de vanguardia, y por otro, 
              proporcionar talento humano especializado que permita a las empresas alcanzar sus 
              objetivos de desarrollo, automatización y transformación digital.
            </p>
            <p>
              Nuestra filosofía se fundamenta en la creencia de que el éxito tecnológico requiere 
              tanto herramientas innovadoras como talento excepcional. Nos preparamos para ser el 
              puente que conecte a las empresas con las soluciones y el capital humano que necesitan 
              para prosperar en la era digital, ofreciendo servicios que van desde el desarrollo de 
              proyectos hasta la provisión de profesionales altamente calificados para roles 
              tecnológicos clave.
            </p>
          </div>
          <div className={styles.storyImage}>
            <img src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=800&auto=format&fit=crop" alt="Equipo LUCQA" />
          </div>
        </div>
      </section>

      <section className={styles.statsSection}>
        <div className={styles.statsContainer}>
          {stats.map((stat, index) => (
            <div key={index} className={styles.statCard}>
              <h3>{stat.value}</h3>
              <p>{stat.label}</p>
            </div>
          ))}
        </div>
      </section>

      <section className={styles.valuesSection}>
        <div className={styles.valuesContainer}>
          <div className={styles.sectionHeader}>
            <h2>Nuestros Valores</h2>
            <p>Principios que guían nuestro trabajo y relaciones</p>
          </div>
          
          <div className={styles.valuesGrid}>
            {values.map((value, index) => (
              <div key={index} className={styles.valueCard}>
                <div className={styles.iconContainer}>
                  {value.icon}
                </div>
                <h3 className={styles.valueTitle}>{value.title}</h3>
                <p className={styles.valueDescription}>{value.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* <section className={styles.teamSection}>
        <div className={styles.teamContainer}>
          <div className={styles.sectionHeader}>
            <h2>Nuestro Equipo</h2>
            <p>Profesionales apasionados detrás de cada proyecto</p>
          </div>
          
          <div className={styles.teamGrid}>
            {teamMembers.map((member, index) => (
              <div key={index} className={styles.teamCard}>
                <div className={styles.memberImage}>
                  <img src={member.image} alt={member.name} />
                  <div className={styles.memberOverlay}>
                    <div className={styles.socialLinks}>
                      <a href={member.social.linkedin} aria-label="LinkedIn">
                        <FaGlobe />
                      </a>
                    </div>
                  </div>
                </div>
                <div className={styles.memberInfo}>
                  <h3>{member.name}</h3>
                  <span className={styles.position}>{member.position}</span>
                  <p>{member.bio}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section> */}

      <section className={styles.ctaSection}>
        <div className={styles.ctaContainer}>
          <div className={styles.ctaContent}>
            <FaAward className={styles.ctaIcon} />
            <h2>¿Listo para trabajar con nosotros?</h2>
            <p>Contáctanos hoy mismo para discutir cómo podemos ayudarte a alcanzar tus objetivos digitales.</p>
            <button className={styles.ctaButton}>
              Contáctanos <FaRocket />
            </button>
          </div>
        </div>
      </section>
    </>
  );
};

export default AboutUs;